<template></template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "dashboard",
  data() {
    return {};
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/Dashboard.vue